export const PlayWhiteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.5 3.2C0.5 2.0799 0.5 1.51984 0.717987 1.09202C0.909734 0.715695 1.21569 0.409734 1.59202 0.217987C2.01984 0 2.5799 0 3.7 0H21.3C22.4201 0 22.9802 0 23.408 0.217987C23.7843 0.409734 24.0903 0.715695 24.282 1.09202C24.5 1.51984 24.5 2.0799 24.5 3.2V20.8C24.5 21.9201 24.5 22.4802 24.282 22.908C24.0903 23.2843 23.7843 23.5903 23.408 23.782C22.9802 24 22.4201 24 21.3 24H3.7C2.5799 24 2.01984 24 1.59202 23.782C1.21569 23.5903 0.909734 23.2843 0.717987 22.908C0.5 22.4802 0.5 21.9201 0.5 20.8V3.2Z"
      fill="#041C1B"
      fillOpacity="0.2"
    />
    <path
      d="M17.8703 11.5448L9.23041 5.67824C9.15764 5.62882 9.07433 5.60184 8.98906 5.60007C8.90379 5.59829 8.81963 5.62179 8.74524 5.66814C8.67086 5.7145 8.60893 5.78203 8.56582 5.8638C8.52272 5.94556 8.5 6.03861 8.5 6.13337V17.8666C8.5 17.9613 8.52272 18.0544 8.56582 18.1362C8.60893 18.2179 8.67086 18.2855 8.74524 18.3318C8.81963 18.3782 8.90379 18.4017 8.98906 18.3999C9.07433 18.3981 9.15764 18.3711 9.23041 18.3217L17.8703 12.4551C17.9404 12.4075 17.9984 12.3406 18.0386 12.2609C18.0789 12.1812 18.1 12.0913 18.1 12C18.1 11.9086 18.0789 11.8188 18.0386 11.7391C17.9984 11.6594 17.9404 11.5925 17.8703 11.5448Z"
      fill="white"
    />
  </svg>
);
